export default __webpack_public_path__ + "static/media/LinkedIn.96423bce.svg";